import { createTrackingUtils } from "..";
import { useCallback, useMemo } from "react";
import { UIFlightData } from "@flights/types";

const utils = createTrackingUtils({
  name: "flights_web_fd_fare_rules_source",
  stages: {
    main: 1,
    same_airline: 2,
    not_same_airline: 3,
    is_owc: 4,
    branded_fare: 5,
    standard_fare: 6,
    checkout_branded_fare: 7,
    checkout_ticket_type: 8
  },
  defaultStage: 1,
  goals: {
    change_cancel_included: 1,
    change_sellable: 2,
    change_not_available: 3,
    cancel_sellable: 4,
    cancel_not_available: 5
  }
});

export const useTrackFareRulesSource = (flight: UIFlightData) => {
  const size = useMemo(() => {
    const { size } = new Set(
      flight.segments.flatMap((s) => s.legs.flatMap((l) => l.flightInfo.carrierInfo?.operatingCarrier)).filter(Boolean)
    );

    return size;
  }, [flight.segments]);

  const locationParams = location.search;
  const urlParams = new URLSearchParams(locationParams);
  const index = urlParams.get("brandedFareIndex");
  const isBrandedFare = !!index && index !== "0";

  return useCallback(() => {
    if (size === 1) {
      utils.stages.same_airline();
    } else {
      utils.stages.not_same_airline();
    }

    if (flight.oneWayCombination) {
      utils.stages.is_owc();
    }

    if (isBrandedFare) {
      utils.stages.branded_fare();
    } else {
      utils.stages.standard_fare();
    }

    return !!utils.trackWithDefaultStage();
  }, [flight.oneWayCombination, isBrandedFare, size]);
};

export default utils;
